module.exports = __webpack_public_path__ + "img/icon-park-outline_doc-search-two.3ec558d2.svg";